import { render, staticRenderFns } from "./ticketDetailComponent.vue?vue&type=template&id=1379eeaf"
import script from "./ticketDetailComponent.vue?vue&type=script&lang=js"
export * from "./ticketDetailComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports